import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function MobileOff({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>MobileOff</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.68488 4.24554C5.40726 4.76904 5.25 5.36616 5.25 6V18C5.25 20.0711 6.92893 21.75 9 21.75H15C17.0711 21.75 18.75 20.0711 18.75 18V17.3107L17.25 15.8107V18C17.25 19.2426 16.2426 20.25 15 20.25H9C7.75736 20.25 6.75 19.2426 6.75 18V6C6.75 5.78982 6.77882 5.58637 6.83272 5.39338L5.68488 4.24554ZM6.64345 3.08279L7.71409 4.15343C8.07857 3.89914 8.52187 3.75 9 3.75H15C16.2426 3.75 17.25 4.75736 17.25 6V13.6893L18.75 15.1893V6C18.75 3.92893 17.0711 2.25 15 2.25H9C8.10727 2.25 7.2874 2.56195 6.64345 3.08279ZM11 16.25C10.5858 16.25 10.25 16.5858 10.25 17C10.25 17.4142 10.5858 17.75 11 17.75H13C13.4142 17.75 13.75 17.4142 13.75 17C13.75 16.5858 13.4142 16.25 13 16.25H11Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M3 2L21 20"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
